import React from 'react'
import { Grid, Typography, Divider, Paper, Box } from '@mui/material'
import '../../../styles/report.css'
import {motion, AnimatePresence} from "framer-motion/dist/framer-motion"
/** 
 * 
 * This component is expecting the following input. 
{
    "Order": "20",
    "Visible": "1",
    "Label": "Demographics",
    "ComponentType": "STANDARD KEY VALUE CARD"
    "ComponentValues":[
         {
            "Label": "Birth sex",
            "Value": "FEMALE"
        },
        {
            "Label": "Gender identity",
            "Value": "MALE"
        },
        {
            "Label": "Age",
            "Value": "28"
        },
        {
            "Label": "Date of birth",
            "Value": "12/14/1994"
        },
        {
            "Label": "Height",
            "Value": "60 ins"
        },
        {
            "Label": "Weight",
            "Value": "95 lbs"
        },
        {
            "Label": "Race",
            "Value": "MULTIRACIAL"
        },
        {
            "Label": "Ethnicity",
            "Value": "DONT KNOW"
        },
    ]
},
*/

const DemographicsComponent = (props) => {

    const data = []
    if (props && props.component) {
        data.push({ Label: props.component.BirthSex.Label, Value: props.component.BirthSex.Value })
        data.push({ Label: props.component.GenderIdentity.Label, Value: props.component.GenderIdentity.Value })
        data.push({ Label: props.component.Age.Label, Value: props.component.Age.Value })
        data.push({ Label: props.component.DoB.Label, Value: props.component.DoB.Value })
        data.push({ Label: props.component.Height.Label, Value: props.component.Height.Value })
        data.push({ Label: props.component.Weight.Label, Value: props.component.Weight.Value })
        data.push({ Label: props.component.Race.Label, Value: props.component.Race.Value })
        data.push({ Label: props.component.Ethnicity.Label, Value: props.component.Ethnicity.Value })
    }



    const DisplayItem = ({ displayValues }) => {


        return (
            <Box sx={{ borderBottom: 1, borderColor: "rgba(200,200,200,0.4)" }}>
                <Grid container direction="row" alignItems="center">
                    <Grid item xs={5}>
                        <Typography variant="body2" align="left">{displayValues.Label}</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography variant="body2" align="left">{displayValues.Value}</Typography>
                    </Grid>
                </Grid>
            </Box>
        )
    }
    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
          opacity: 1, x: 0, y: 0,
          transition: {
            delay: 0.1,
            duration: 0.5,
          }
        }
      }
    return (
        <Grid item lg={4} md={4} sm={4} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>

<motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%'}}>
                <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px', height: '100%' }}>
                    <Grid container direction="row" alignItems="center" justifyContent="center">
                        <Grid item xs={12}>
                            <Typography variant="h5" align="center">{props.component.Label}</Typography>
                        </Grid>
                        <Grid item xs={12} m={1}>
                            <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                        </Grid>
                        <Grid item xs={12}>
                            {
                                data && data.map((displayValues, index) => {
                                    return (
                                        <DisplayItem displayValues={displayValues} key={"demographics" + index} />
                                    )
                                })
                            }
                        </Grid>
                    </Grid>
                </Paper>
            </motion.div>
        </Grid>
    )
}

export default DemographicsComponent